import { render, staticRenderFns } from "./SetsRateCard.vue?vue&type=template&id=31f0555b&"
import script from "./SetsRateCard.vue?vue&type=script&lang=js&"
export * from "./SetsRateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports